// Aviso de lectura incompleta: un listado topado o a medias no se presenta como completo.
import { AlertTriangle } from 'lucide-react';

export interface TruncatedNoticeProps {
    title: string;
    body: string;
}

export function TruncatedNotice({ title, body }: TruncatedNoticeProps) {
    return (
        <div
            role="status"
            className="flex items-start gap-2 rounded-md border border-warning-soft-border bg-warning-soft px-3 py-2 text-[11.5px]"
        >
            <AlertTriangle className="mt-[1px] size-4 flex-none text-warning" aria-hidden />
            <p>
                <strong>{title}</strong> {body}
            </p>
        </div>
    );
}
